import React, { Fragment, } from 'react';
import { keyBy, sortBy, } from 'lodash';
import { toast } from 'react-toastify';

import firebase from '../firebase';
import { batch } from '../shared/firebase';
import { fields as settingFields, } from '../shared/models/changesTableImportSetting';
import ModalButton from './ModalButton';
import EditButton from './EditButton';
import ProgressButton from './ProgressButton';
import ModelFormModal from './modals/ModelFormModal';

const db = firebase.firestore();
const collectionName = 'cashes';

export default function CashesImportModalButton (props) {
  const {
    company, itemsRef, trialBalances, accountItems, accountItemsByName,
    subsidiaryId, period, yearMonth, existingItems, savedSetting, disabled,
  } = props;
  const settingRef = company.ref.collection('changesTableImportSettings').doc(`${collectionName}_${subsidiaryId}`);
  const accountItemsById = keyBy(accountItems, 'id');

  // 現状の取込ロジックと同じソースで取込対象候補を作る
  const filterTrials = _ => _.account_category_name === '現金・預金' && Math.abs(_.closing_balance) > 0;
  const balancesByAccountItemId = keyBy(
    trialBalances.filter(_ => accountItemsByName[_.account_item_name] != null),
    _ => accountItemsByName[_.account_item_name].id,
  );

  // 設定があればそれ、無ければ filterTrials 通過科目を対象にする
  const targetAccountItemIds = savedSetting?.accountItemIds
    ?? trialBalances.filter(filterTrials).map(_ => accountItemsByName[_.account_item_name]?.id).filter(_ => _);
  const selectedAccountItems = sortBy(targetAccountItemIds.map(_ => accountItemsById[_]).filter(_ => _), 'name');

  const onClickImport = async () => {
    if(!window.confirm('試算表から取り込みます。よろしいですか？')) return;

    const targets = targetAccountItemIds.map(_ => balancesByAccountItemId[_]).filter(_ => _);
    await batch(db, targets, (batch, balance) => {
      const accountItemId = accountItemsByName[balance.account_item_name]?.id;
      if(accountItemId == null || existingItems.some(_ => _.accountItemId === accountItemId)) return;

      batch.set(itemsRef.doc(), {
        accountItemId,
        amount: balance.closing_balance,
        note: '',
        subsidiaryId,
        period,
        yearMonth,
        createdAt: new Date(),
      });
    });
    toast.success('試算表から取り込みました。');
  };

  return (
    <ModalButton
      color="primary"
      label="試算表から取込み"
      title="試算表から取込み"
      disabled={disabled}
      content={_ => (
        <Fragment>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="text-muted small">取込む科目</span>
            <EditButton
              label="設定"
              icon={<span className="fas fa-cog" />}
              color="secondary"
              outline
              size="sm"
              type="set"
              itemRef={settingRef}
              item={savedSetting ?? { accountItemIds: targetAccountItemIds }}
              FormModal={ModelFormModal}
              processValues={_ => ({ ..._, collectionName, subsidiaryId, updatedAt: new Date(), })}
              formProps={{ title: '取込設定', fields: settingFields({ accountItems }), }}
            />
          </div>
          <div className="overflow-auto mb-3" style={{ maxHeight: 'min(400px, 50vh)', }}>
            {
              selectedAccountItems.length > 0 ? (
                <table className="table table-sm table-bordered mb-0">
                  <tbody>
                    {
                      selectedAccountItems.map(_ => (
                        <tr key={_.id}>
                          <td>
                            {_.name}
                            {existingItems.some(e => e.accountItemId === _.id) && <span className="badge badge-light ml-2">取込済み</span>}
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              ) : (
                <div className="text-muted text-center py-3">取込む科目がありません。「設定」から科目を選択してください。</div>
              )
            }
          </div>
          <div className="d-flex justify-content-end">
            <ProgressButton color="primary" process={onClickImport} disabled={selectedAccountItems.length === 0}>
              取込
            </ProgressButton>
          </div>
        </Fragment>
      )}
    />
  );
};
